module.exports = __webpack_public_path__ + "static/media/Curoflow_telemedicine_platform_logo_white.58c50744.svg";